@if (!showOnlyOutOfStock || stock?.stockLevelStatus === 'outOfStock') {
    <div class="d-inline">
        <!--Here we could change the status color by setting new stock-status-{{stock.stockLevelStatus}}-->
        <div
            [ngClass]="{ 'stock-status-icon': stock?.terminalProduct,
        'stock-status-instock': stock?.stockLevelStatus==='inStock',
        'stock-status-lowstock': stock?.stockLevelStatus==='lowStock',
        'stock-status-outofstock': stock?.stockLevelStatus==='outOfStock'}"
            class="stock-status">
            @if (stock?.terminalProduct) {
                <i
                    class="icon-inline aimo-icon icon-truck icon-sm"
                    triggers="mouseenter:mouseleave"
                    container="body"
                    popoverClass="popover-default"
                    [ngbPopover]="'aimo.product.terminalProduct' | cxTranslate"></i>
            }
        </div>

        @if (printStockName) {
            <span> {{ stock?.warehouse?.name }}: </span>
        }
        @if (!stock?.terminalProduct) {
            <span class="d-none d-md-inline-block">
      <ng-container *ngTemplateOutlet="stockLabel"> </ng-container>
    </span>
        }
        @if (stock?.terminalProduct) {
            <span class="d-none d-md-inline-block">
      {{ stock?.text }}
    </span>
        }
        @if (stock?.text) {
            <span class="d-inline-block d-md-none">
      <ng-container *ngTemplateOutlet="stockLabel"> </ng-container>
    </span>
        }
    </div>

    <ng-template #stockLabel>
        @if (outOfStock) {
            {{ stock?.text }}
        }
        @if (!outOfStock) {
            @if (!suggestiveMode) {
                @if (!stock?.terminalProduct) {
                    {{ 'aimo.stock.availability' | cxTranslate: {amount: stock?.text} }}
                }
                @if (stock?.terminalProduct) {
                    {{ stock?.text }}
                }
            }
            @if (suggestiveMode) {
                {{ stock?.text }}
            }
        }
    </ng-template>
}
